import Lockr from 'lockr';
import { hex_hmac_sha256 } from './HmacSHA256Utils.js';

export { encrypt, getQueryString };

/**
 * 参数加密
 */
async function encrypt(params) {
  // clone对象避免更改params
  var tmp = {};
  extend(tmp, params || {});
  var state = Lockr.get('$state') || {};
  var token = state.token;
  var secret = state.secret;
  var sequence = Date.now().toString();
  var key = secret + '-' + sequence;
  // 将token,secret,sequence设置到参数中
  tmp.sequence = sequence;
  tmp.token = token;
  // 生成摘要设置到参数中
  tmp.digest = digest(key, tmp);
  return tmp;
}

/**
 * 根据密钥和参数对象生成摘要
 */
function digest(encryptKey, params) {
  // 参数按照key排序
  var sortedkeys = Object.keys(params).sort();
  // 根据key拼接value
  var content = '';
  for (var i = 0; i < sortedkeys.length; i++) {
    var key = sortedkeys[i];
    // 如果值不为null且undefined时，拼接到content中用以加密；反之，若为null或undefined则忽略
    if ('undefined' != typeof params[key] && null != params[key]) {
      content += params[key];
    }
  }

  // 生成摘要并返回
  return hex_hmac_sha256(encryptKey, content);
}

/**
 * 获取url中参数
 */
function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = decodeURI(window.location.search)
    .substr(1)
    .match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

/* eslint-disable */ 
/**
 * jquery2.extend
 * 实现对对象的复制
 */
function extend() {
  var options,
    name,
    src,
    copy,
    copyIsArray,
    clone,
    target = arguments[0] || {},
    i = 1,
    length = arguments.length,
    deep = false;

  if (typeof target === 'boolean') {
    deep = target;

    target = arguments[i] || {};
    i++;
  }

  if (typeof target !== 'object' && !$.isFunction(target)) {
    target = {};
  }

  if (i === length) {
    target = this;
    i--;
  }

  for (; i < length; i++) {
    if ((options = arguments[i]) != null) {
      for (name in options) {
        src = target[name];
        copy = options[name];

        if (target === copy) {
          continue;
        }

        if (
          deep &&
          copy &&
          ($.isPlainObject(copy) || (copyIsArray = $.isArray(copy)))
        ) {
          if (copyIsArray) {
            copyIsArray = false;
            clone = src && $.isArray(src) ? src : [];
          } else {
            clone = src && $.isPlainObject(src) ? src : {};
          }

          target[name] = $.extend(deep, clone, copy);
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }

  return target;
}
/* eslint-disable */ 
